// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class PFixField {
    constructor(fieldId, buffer) {
        this.FieldId = fieldId;
        if (buffer && buffer !== null) {
            this.ReadValue(buffer);
        }
    }
    ReadValue(buffer) {
        // virtual
    }
    Write(buffer, maxServerNumber) {
        // virtual
    }
    toString() {
        if ( /* this.FieldId === -1 || */this.Value === null) {
            return '<empty>';
        }
        return '#' + this.FieldId + '=' + this.Value.toString();
    }
    SerializeValue() {
        if (this.Value !== null && this.Value !== undefined) {
            return this.Value.toString();
        }
        else {
            return '';
        }
    }
}
